import { render, staticRenderFns } from "./PanelMiniInfo.vue?vue&type=template&id=2ba0228c"
import script from "./PanelMiniInfo.vue?vue&type=script&lang=js"
export * from "./PanelMiniInfo.vue?vue&type=script&lang=js"
import style0 from "./PanelMiniInfo.vue?vue&type=style&index=0&id=2ba0228c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports